import Box from "@mui/material/Box";

const BoldPrefixUntilColon = ({ text = "" }) => {
  const colonIndex = text.indexOf(":");
  if (colonIndex === -1) {
    return text;
  }

  return (
    <>
      <Box component="span" sx={{ fontWeight: 700 }}>
        {text.slice(0, colonIndex + 1)}
      </Box>
      {text.slice(colonIndex + 1)}
    </>
  );
};

export default BoldPrefixUntilColon;
